import { render, staticRenderFns } from "./NotificationsModal.vue?vue&type=template&id=64e89278&scoped=true"
import script from "./NotificationsModal.vue?vue&type=script&lang=js"
export * from "./NotificationsModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationsModal.vue?vue&type=style&index=0&id=64e89278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e89278",
  null
  
)

export default component.exports